import { render } from "./famousCourseHumanityVideo.vue?vue&type=template&id=b73ed622&scoped=true"
import script from "./famousCourseHumanityVideo.vue?vue&type=script&lang=js"
export * from "./famousCourseHumanityVideo.vue?vue&type=script&lang=js"

import "./famousCourseHumanityVideo.vue?vue&type=style&index=0&id=b73ed622&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b73ed622"]])

export default __exports__